import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-051f306e")

_pushScopeId("data-v-051f306e")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "sticky" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-back" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_van_sticky = _resolveComponent("van-sticky")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    ($setup.temp)
      ? (_openBlock(), _createBlock(_component_van_sticky, { key: 0 }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: "/realtime",
                class: "icon-button",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.dialogShow = true))
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
})